import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
// The following two imports is for the theme.
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';

// This import is for the language syntax highlighting.
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import { useTranslation } from 'react-i18next';
import WidgetCustom from '../../../../models/widget-custom';
import useAppContext from '../../../../context/useAppContext';
import { Button, FrameCard, WeezHeader, ToastContext } from '@weezevent/nacre';
import Style from './widget-custom.module.css';
import { useHistory } from 'react-router-dom';

export default function WidgetCustomOrganization() {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();
    const history = useHistory();
    const toast = React.useContext(ToastContext);

    const [customs, , sync] = WidgetCustom.useApiModel({
        organizationId: organization.id
    });
    const [custom, setCustom] = React.useState(null);

    React.useEffect(() => {
        if (customs && customs.length) {
            setCustom(customs[0]);
        }
    }, [customs, setCustom]);

    const handleSubmit = React.useCallback(() => {
        let cust = new WidgetCustom(custom);
        cust.save({
            organizationId: organization.id
        }).then(() => {
            sync();
            toast.success(t('ticket.widgets.common.module_custom_success'));
        });
    }, [custom, sync, organization]);

    const css = React.useMemo(() => {
        if (custom) {
            return custom.values['css'];
        }
        return null;
    }, [custom]);

    const js = React.useMemo(() => {
        if (custom) {
            return custom.values['js'];
        }
        return null;
    }, [custom]);

    return (
        <div>
            <WeezHeader
                title={t('ticket.widgets.common.module_custom_header')}
                backLink={{
                    onClick: () => history.push(`/ticket/O${organization.pk}/widgets`)
                }}
                rightComponent={<Button primary label={t('ticket.common.action.save')} onClick={handleSubmit} />}
            />
            <FrameCard id="design" title={t('ticket.widgets.common.module_custom')} subtitle={t('ticket.widgets.common.module_custom_subtitle')}>
                <div className={Style['css-editor']}>
                    <div className={Style['css-editor-title']}>{t('ticket.widgets.event.config.css')}</div>
                    <CodeMirror
                        value={css || null}
                        options={{
                            mode: 'css',
                            theme: 'monokai',
                            lineNumbers: true
                        }}
                        onChange={() => {}}
                        onBeforeChange={(editor, data, value) => {
                            let tmpValues = custom ? { ...custom.values } : {};
                            tmpValues['css'] = value;
                            setCustom({
                                ...custom,
                                values: tmpValues
                            });
                        }}
                    />
                </div>

                <div className={Style['css-editor']}>
                    <div className={Style['css-editor-title']}>{t('ticket.widgets.common.custom_js')}</div>
                    <CodeMirror
                        value={js || null}
                        options={{
                            mode: 'javascript',
                            theme: 'monokai',
                            lineNumbers: true
                        }}
                        onChange={() => {}}
                        onBeforeChange={(editor, data, value) => {
                            let tmpValues = custom ? { ...custom.values } : {};
                            tmpValues['js'] = value;
                            setCustom({
                                ...custom,
                                values: tmpValues
                            });
                        }}
                    />
                </div>
            </FrameCard>
        </div>
    );
}
